import { ApiBind, CommonSearchParam } from './common-search-param.model';


export class PlatformSDKVersionGroupSearchParam extends CommonSearchParam {

  constructor(
    platformId?: number,
    adFormats?: string,
    sdkVersionGroupSettings?: string,
    sdkVersionGroupId?: number,
  ) {
    super();
    this.platformId = platformId;
    this.adFormats = adFormats;
    this.sdkVersionGroupSettings = sdkVersionGroupSettings;
    this.sdkVersionGroupId = sdkVersionGroupId;
  }

  @ApiBind({ column: 'platform_id' })
  platformId: number;

  @ApiBind({ column: 'ad_formats' })
  adFormats: string;

  @ApiBind({ column: 'sdk_version_group_settings' })
  sdkVersionGroupSettings: string;

  @ApiBind({ column: 'sdk_version_group_id' })
  sdkVersionGroupId: number;
}
